import { TVideosAssignmentAction, VideosAssignmentActionTypes } from './videosAssignmentActions';
import { IVideosAssignmentState } from './videosAssignmentContext';

export const videosAssignmentReducer = (
	state: IVideosAssignmentState,
	action: TVideosAssignmentAction,
): IVideosAssignmentState => {
	switch (action.type) {
		case VideosAssignmentActionTypes.SET_VIDEOS_FOR_ASSIGN:
			return {
				...state,
				videosForAssign: action.payload.videosForAssign,
			};
		case VideosAssignmentActionTypes.CHANGE_SEARCH_STRING:
			return {
				...state,
				searchString: action.payload.searchString,
				IDsSelectedVideos: [],
				currentPage: 1,
			};
		case VideosAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_ALL_CUSTOMERS:
			return {
				...state,
				searchStringForAllCustomers: action.payload.searchStringForAllCustomers,
			};
		case VideosAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_RESTAURANTS:
			return {
				...state,
				searchStringForRestaurants: action.payload.searchStringForRestaurants,
			};
		case VideosAssignmentActionTypes.CHANGE_SEARCH_STRING_FOR_VIDEOS:
			return {
				...state,
				searchStringForVideos: action.payload.searchStringForVideos,
			};
		case VideosAssignmentActionTypes.SET_STUDIO:
			return {
				...state,
				selectedStudio: action.payload.selectedStudio,
				IDsSelectedVideos: [],
				isUnassignedVideos: false,
				currentPage: 1,
			};
		case VideosAssignmentActionTypes.SET_CATEGORY:
			return {
				...state,
				selectedCategory: action.payload.selectedCategory,
				IDsSelectedVideos: [],
				isUnassignedVideos: false,
				currentPage: 1,
			};
		case VideosAssignmentActionTypes.TOGGLE_UNASSIGNED_VIDEOS:
			return {
				...state,
				isUnassignedVideos: !state.isUnassignedVideos,
				currentPage: 1,
			};
		case VideosAssignmentActionTypes.RESET_SELECTED_CONTROLS:
			return {
				...state,
				selectedStudio: null,
				selectedCategory: null,
				isUnassignedVideos: false,
				IDsSelectedVideos: [],
				currentPage: 1,
				searchString: '',
			};
		case VideosAssignmentActionTypes.SET_SORT_BY:
			return {
				...state,
				sortBy: action.payload.sortBy,
				IDsSelectedVideos: [],
			};
		case VideosAssignmentActionTypes.SET_IDS_SELECTED_VIDEOS:
			return {
				...state,
				IDsSelectedVideos: action.payload.IDsSelectedVideos,
			};
		case VideosAssignmentActionTypes.CHANGE_ACTIVE_ITEM_TO_DISPLAY:
			return {
				...state,
				activeItemToDisplay: action.payload.activeItemToDisplay,
			};
		case VideosAssignmentActionTypes.SET_SHOW_BREADCRUMBS:
			return {
				...state,
				isShowBreadcrumbs: action.payload.isShowBreadcrumbs,
			};
		case VideosAssignmentActionTypes.SET_ALL_CUSTOMERS:
			return {
				...state,
				allCustomers: action.payload.allCustomers,
			};
		case VideosAssignmentActionTypes.SET_IDS_SELECTED_CUSTOMERS:
			return {
				...state,
				IDsSelectedCustomers: action.payload.IDsSelectedCustomers,
				restaurants: action.payload.restaurants,
				IDsSelectedRestaurants: action.payload.IDsSelectedRestaurants,
				videos: action.payload.videos,
			};
		case VideosAssignmentActionTypes.SET_IDS_SELECTED_RESTAURANTS:
			return {
				...state,
				IDsSelectedRestaurants: action.payload.IDsSelectedRestaurants,
				videos: action.payload.videos,
			};
		case VideosAssignmentActionTypes.SET_VIDEOS:
			return {
				...state,
				videos: action.payload.videos,
				IDsSelectedVideos: action.payload.IDsSelectedVideos,
			};
		case VideosAssignmentActionTypes.CHANGE_TYPE_OF_MODAL_WINDOW:
			return {
				...state,
				typeOfModalWindow: action.payload.typeOfModalWindow,
			};
		case VideosAssignmentActionTypes.CHANGE_CURRENT_PAGE:
			return {
				...state,
				currentPage: action.payload.currentPage,
				IDsSelectedVideos: [],
			};
		case VideosAssignmentActionTypes.RESET_CHANGES:
			return {
				...state,
				activeItemToDisplay: 'customers',
				IDsSelectedCustomers: {},
				restaurants: [],
				IDsSelectedRestaurants: {},
				videos: [],
				typeOfModalWindow: null,
			};
		default:
			return state;
	}
};
